<template>
  <div>
    <input class="hidden test" @change="emitFiles" type="file" name="file" id="file" :accept="accept"/>
    <label class="block cursor-pointer" for="file"><slot/></label>
  </div>
</template>

<script>

export default {
  name: 'InputFile',
  props: {
    accept: {
      type: String,
      default: ""
    }
  },
  methods: {
    emitFiles(e) {
      this.$emit('change', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/input-file.vue